import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from '../../lib'
import {doREQUEST_ERROR, doREQUEST_COMPLETE} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_WORKSPACE_ALL_QUESTIONNAIRE_FETCH = 'REQUEST_WORKSPACE_ALL_QUESTIONNAIRE_FETCH'
export const doREQUEST_WORKSPACE_ALL_QUESTIONNAIRE_FETCH = createDoRequestAction(
  REQUEST_WORKSPACE_ALL_QUESTIONNAIRE_FETCH,
)

export const requestWorkspaceAllQuestionnaireFetchActionCreators = {
  doREQUEST_WORKSPACE_ALL_QUESTIONNAIRE_FETCH,
}

export function* requestWorkspaceAllQuestionnaire({
  payload,
  setRequestResult,
}: {
  payload: {requestId: string; workspaceId: string}
  type: string
  setRequestResult: (result: any) => void
}): SagaIterator {
  debug('saga*requestWorkspaceAllQuestionnaire')
  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        workspaceId: v.string().uuid().exist(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_WORKSPACE_ALL_QUESTIONNAIRE_FETCH,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {workspaceId} = payload
  const accessToken = yield call(getToken)
  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/workspace-all-questionnaire-fetch`,
    accessToken,
    data: {
      workspaceId,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_WORKSPACE_ALL_QUESTIONNAIRE_FETCH,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/workspace-all-questionnaire-fetch',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_WORKSPACE_ALL_QUESTIONNAIRE_FETCH,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* workspaceAllQuestionnaireFetchSaga() {
  yield takeEvery(REQUEST_WORKSPACE_ALL_QUESTIONNAIRE_FETCH, requestWorkspaceAllQuestionnaire)
}
